import { useMutation } from '@tanstack/react-query';
import { api } from 'src/services';
import { useAppointmentListClient } from './useGetAppointmentList';

export type UseCreateAppointmentPayload = {
  appointment: Record<string, unknown>;
  patient: Record<string, unknown>;
  notification: Record<string, unknown>;
};

export type CreateAppointmentResponse = {
  message: string;
};

export const useCreateAppointment = () => {
  const { invalidate } = useAppointmentListClient();
  return useMutation({
    mutationKey: ['createAppointment'],
    mutationFn: (payload: UseCreateAppointmentPayload) =>
      api.post('/patientAppointment', payload).then((res) => res.data),
    onSuccess: () => {
      invalidate();
    },
  });
};
